import React, { useEffect } from 'react';

const Home: React.FC = () => {
  // Scroll to top when component mounts
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      {/* Hero Section */}
      <section className="hero">
        <div className="container">
          <div className="hero-content">
            <div className="hero-text">
                <h1>Clean. Functional.<br />Built for Lifters.</h1>
              <p className="hero-subtitle">
                Early-stage gym app developed with user feedback from day one.
                No ads, no paywalls, no feature bloat - just straightforward workout tracking.
              </p>              <div className="hero-buttons">
                <div className="platform-buttons">
                  <a href="https://play.google.com/store/apps/details?id=com.glassedgesoftware.gymapp" className="btn btn-platform btn-download">
                    <span className="platform-name">Android</span>
                    <span className="platform-action">Download Now</span>
                  </a>
                  <a href="https://apps.apple.com/us/app/gym-edge/id6747607694" className="btn btn-platform btn-download">
                    <span className="platform-name">iOS</span>
                    <span className="platform-action">Download Now</span>
                  </a>
                </div>
                <a href="https://discord.gg/ZFZ3aaH3vt" className="btn btn-secondary btn-community" target="_blank" rel="noopener noreferrer">
                  Join Discord Community
                </a>
              </div>
            </div>
            <div className="hero-image">
              <img src="/feature-graphic.png" alt="Gym Edge Interface" />
            </div>
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section id="features" className="features">
        <div className="container">
          <h2>Built for Real Workouts</h2>
          <div className="features-grid">
            <div className="feature-card">
              {/* <img src="/placeholder-icon-tracking.png" alt="Workout Tracking" className="feature-icon" /> */}
              <h3>Efficient Tracking</h3>
              <p>Log your lifts quickly without unnecessary complications. Focus on your workout, not the app.</p>
            </div>
            <div className="feature-card">
              {/* <img src="/placeholder-icon-privacy.png" alt="Data Privacy" className="feature-icon" /> */}
              <h3>Data Stays Local</h3>
              <p>All your workout data remains on your device. No cloud storage, no data mining, complete privacy.</p>
            </div>
            <div className="feature-card">
              {/* <img src="/placeholder-icon-clean.png" alt="Clean Interface" className="feature-icon" /> */}
              <h3>Clean Interface</h3>
              <p>Designed to get out of your way. No ads, no premium tiers, just the tools you need.</p>
            </div>
            <div className="feature-card">
              {/* <img src="/placeholder-icon-community.png" alt="Community Driven" className="feature-icon" /> */}
              <h3>Community Driven</h3>
              <p>Every feature addition comes from real user requests. Help shape the app's development.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Status Section */}
      <section className="status">
        <div className="container">
          <div className="status-content">
            <h2>Early Stage Development</h2>
            <p>
              This is early-stage software that will grow based on user feedback. We're not trying to
              reinvent fitness - just make a tool that works the way people actually train.
            </p>
            <p>
              If you're looking for something comprehensive right now, this probably isn't it yet.
              But if you want to help shape a gym app that prioritizes function over flash,
              we'd appreciate the feedback.
            </p>
          </div>
        </div>
      </section>

      {/* Download Section */}
      <section id="download" className="download">
        <div className="container">
          <h2>Downloads</h2>
          <div className="download-options">
            <div className="download-card">
              {/* <img src="/placeholder-android-logo.png" alt="Android" className="platform-logo" /> */}
              <h3>Android</h3>
              <p>Available now on Google Play Store</p>
              <a href="https://play.google.com/store/apps/details?id=com.glassedgesoftware.gymapp" className="btn btn-primary">Download on Google Play</a>
            </div>
            <div className="download-card">
              {/* <img src="/placeholder-ios-logo.png" alt="iOS" className="platform-logo" /> */}
              <h3>iOS</h3>
              <p>Available now on the App Store</p>
              <a href="https://apps.apple.com/us/app/gym-edge/id6747607694" className="btn btn-primary">Download on App Store</a>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Home;
